import { TestManagementView } from '@/components/mentor/test-management-view'

/**
 * Admin Create Tests - Same full functionality as Mentor Test Management:
 * - Create/Edit/Delete tests
 * - Test details, schedule, contributors, questions, review
 * - Chapter-wise, Daily, Weekly, Monthly, Full Series
 * - Subject selection (Physics, Chemistry, Biology, Botany, Zoology)
 * - Question bank import, bulk upload, manual entry
 * Separate admin page - does not redirect to mentor portal.
 */
export function AdminTestsView() {
    return (
        <div className="space-y-4 pb-24 lg:pb-0">
            <div className="mb-4">
                <h2 className="text-2xl font-bold text-theme-primary">Create & Manage Tests (Admin)</h2>
                <p className="text-sm text-theme-secondary">Full access: Create tests, configure schedule, assign contributors, add questions. Same UI as mentor with all admin permissions.</p>
            </div>
            <TestManagementView />
        </div>
    )
}
